import { Users, Calendar, MessageSquare, Layers, Sparkles } from "lucide-react";

// Purely VISUAL grouping layer for the hub-and-spoke dashboard. Does not alter
// CONNECTIONS_CATALOG data/keys/behavior — each capability keeps its own
// status, sub-capabilities and SetupDrawer flow exactly as before.
export const MEGA_GROUPS = [
  {
    key: "customer_access",
    label: "Customer Access",
    subtitle: "Enable seamless customer experiences and external access.",
    icon: Users,
    iconBg: "bg-blue-100 dark:bg-blue-500/15",
    iconColor: "text-blue-600 dark:text-blue-400",
    side: "left",
    capabilityKeys: ["customer_intake", "customer_management"],
  },
  {
    key: "operations_productivity",
    label: "Operations & Productivity",
    subtitle: "Keep your team organized and work efficiently.",
    icon: Calendar,
    iconBg: "bg-violet-100 dark:bg-violet-500/15",
    iconColor: "text-violet-600 dark:text-violet-400",
    side: "left",
    capabilityKeys: ["scheduling_operations", "finance"],
  },
  {
    key: "communication",
    label: "Communication",
    subtitle: "Stay connected with your customers and team.",
    icon: MessageSquare,
    iconBg: "bg-sky-100 dark:bg-sky-500/15",
    iconColor: "text-sky-600 dark:text-sky-400",
    side: "right",
    capabilityKeys: ["team_communication", "customer_experience"],
  },
  {
    key: "business_tools",
    label: "Business Tools",
    subtitle: "Connect essential business applications.",
    icon: Layers,
    iconBg: "bg-teal-100 dark:bg-teal-500/15",
    iconColor: "text-teal-600 dark:text-teal-400",
    side: "right",
    capabilityKeys: ["documents_productivity"],
  },
  {
    key: "additional_ai",
    label: "Additional & AI",
    subtitle: "Enhance your workflows with additional tools and AI.",
    icon: Sparkles,
    iconBg: "bg-purple-100 dark:bg-purple-500/15",
    iconColor: "text-purple-600 dark:text-purple-400",
    side: "right",
    capabilityKeys: ["automation_ai"],
  },
];

export const FILTER_PILLS = [
  { key: null, label: "All Connections" },
  { key: "customer_access", label: "Customer Access" },
  { key: "business_tools", label: "Business Tools" },
  { key: "communication", label: "Communication" },
  { key: "operations_productivity", label: "Productivity" },
  { key: "additional_ai", label: "Other" },
];
